import { render, staticRenderFns } from "./administracion-equipos-editar.vue?vue&type=template&id=053e6024&scoped=true&"
import script from "./administracion-equipos-editar.vue?vue&type=script&lang=js&"
export * from "./administracion-equipos-editar.vue?vue&type=script&lang=js&"
import style0 from "./administracion-equipos-editar.vue?vue&type=style&index=0&id=053e6024&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053e6024",
  null
  
)

export default component.exports